<template>
<v-card
    v-if="value != null"
    style="position: relative"
>
    <v-card-title>{{value.subject}}</v-card-title>
    <v-card-subtitle><b>{{value.by_employee_label}}</b>, {{pretty_time}}</v-card-subtitle>
    <v-card-text>
        
        <m-showdown
            :value="value.body"
        />

        <div
            v-if="value.blob_meta_data.length > 0"
            style="margin-top: 15px"
        >
            <b>Attachments</b>
            <ul>
                <li
                    v-for="(item, index) in value.blob_meta_data"
                    :key="'blob_'+index"
                >
                
                    <a
                        :href="$rc.getSignedInOnlyBlobUrl(item.object_name)"
                        _target="blank"
                    >
                        {{item.label}}
                    </a>
                </li>
            </ul>
        </div>

        <div
            v-if="value.ack_before_access"
            style="font-weight: 700; margin-top: 15px"
        >
            This note will be displayed and must be acknowledged before a RedChirp staff member can sign in as any user in this organization.
        </div>

    </v-card-text>

    <div
            style="position: absolute; right: 15px; top: 15px"
            v-if="!history_mode"
        >
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit()"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                 <v-list-item
                    v-on:click="onClickViewEditHistory()"
                    v-if="value.time_last_modified != value.time_created"
                >
                    <v-list-item-title>View edit history...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 

        </div>
</v-card>
</template>

<script>
const Time = require('@/js/time.js');
export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },

        history_mode: {
            type: Boolean,
            default: function() { return false; }
        }
    },

    methods: {
        onClickEdit()
        {
            this.$emit('on-click-edit-note', this.value.note_id);
        },

        onClickViewEditHistory()
        {
            this.$emit('on-click-view-edit-history', this.value.note_id);
        },
    },

    computed: {
        pretty_time() {
            if ( this.value == null )
                return null;

            if ( this.history_mode )
                return Time.getLongTimestamp(this.value.time_note);

            return Time.getLongTimestamp(this.value.time_created);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>